// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".UO9cdmPM8bw2y9-6PKGhBQ\\=\\= {\n    text-align: center;\n}\n.JbrJTgJeGbnM0z3yiLsw\\+A\\=\\= {\n    width: 100%;\n}\n.JIfteTxfHwYO3GUINlcWcg\\=\\= {\n    margin: 0 auto;\n    width: 80%;\n}", "",{"version":3,"sources":["webpack://./src/membership/styles/UserListForEmailVerification.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;AACf;AACA;IACI,cAAc;IACd,UAAU;AACd","sourcesContent":[".title {\n    text-align: center;\n}\n.grid {\n    width: 100%;\n}\n.form {\n    margin: 0 auto;\n    width: 80%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": "UO9cdmPM8bw2y9-6PKGhBQ==",
	"grid": "JbrJTgJeGbnM0z3yiLsw+A==",
	"form": "JIfteTxfHwYO3GUINlcWcg=="
};
export default ___CSS_LOADER_EXPORT___;
